export default "__VITE_ASSET__DnCdQkuU__"